"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var FlexLayout_1 = __importDefault(require("./FlexLayout"));
exports.default = FlexLayout_1.default;